import { useDebugValue, useMemo } from 'react';
import { ViewerURLParam } from '../../Viewer/types/ViewerURLParam';

export enum OverlayURLParam {
  ADMIN = 'admin',
  CLICK_TRACK_DEBUG = 'clicktrack_debug',
  COLORS_DEBUG = 'colors_debug',
  DISABLE_NEARBY = 'disableNearby',
  DISPLAY = 'display',
  FAMILY = 'family',
  FLOOR_PLAN_MODE = 'f',
  HIDE_BUTTONS = 'hideButtons',
  HIDE_CAROUSEL = 'hideCarousel',
  HIDE_FULL_SCREEN = 'hideFullScreen',
  HIDE_RIGHT_MENU = 'hideRightMenu',
  HIDE_SHARE_LIVE = 'hideShareLive',
  HIDE_TABS = 'hideTabs',
  ID = 'id',
  IS_ILS = 'isILS',
  PID = 'pid',
  SOURCE_ID = 'sourceId',
  START_SCREEN = 'startScreen',
  THEME_DEBUG = 'theme_debug',
  TOUR = 'tour',
  TRACKING_TOKEN = 'tracking_token',
}

export const HIDE_BUTTONS_SEPARATOR = ',';
export const HIDE_TABS_SEPARATOR = ',';

const PRESENCE_PARAMS: string[] = [
  OverlayURLParam.CLICK_TRACK_DEBUG,
  OverlayURLParam.FLOOR_PLAN_MODE,
  OverlayURLParam.IS_ILS,
];

export default function useURLParam(name: OverlayURLParam | ViewerURLParam) {
  const value = useMemo(() => {
    const params = new URLSearchParams(window.location.search);

    if (PRESENCE_PARAMS.includes(name)) {
      return params.has(name) === true ? 'true' : 'false';
    }

    return params.get(name) ?? '';
  }, [name]);

  useDebugValue(value, (v) => `${name}=${v}`);

  return value;
}
